import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { useSaveRecordEnrichableCount } from '@aibees/elephant/hooks/people/use-save-record-enrichable-count';
import { CreditUsageType } from '@aibees/shared/definition';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { InfoItem } from '../enrich-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { UpdateProfileInsightsDialogProps as Props } from './types';

export const UpdateProfileInsightsDialog = memo(
  ({ className, onClose, open, table }: Props) => {
    const { enrichable, isLoading: countLoading } =
      useSaveRecordEnrichableCount(
        SaveRecordAction.CONTACT_UPDATE_PROFILE,
        open ? table : undefined
      );

    const { credit } = useCreditUsageItem(
      CreditUsageType.CONTACT_PROFILE_UPDATE
    );

    const { handleEnrich, isLoading } = useEnrichPersonSaveRecord(
      SaveRecordAction.CONTACT_UPDATE_PROFILE,
      onClose,
      table,
      enrichable
    );

    const informations: InfoItem[] = [
      {
        count: enrichable,
        label: 'records can be updated.',
      },
    ];

    return (
      <Styled.Wrapper
        className={classnames('UpdateProfileInsightsDialog', className)}
        sx={SX.root}
        open={open}
        onClose={onClose}
        icon="refresh-user"
        title="Update Profile Insights"
        informations={informations}
        cost={credit}
        onSubmit={handleEnrich}
        enrichLoading={isLoading}
        countLoading={countLoading}
        disableEnrich={!enrichable || enrichable === 0}
        unEnrichableHelperText="The selected contacts profile insights are already up-to-date and don't need updating."
        recordsCount={table?.selection.included.length || 0}
      />
    );
  }
);

UpdateProfileInsightsDialog.displayName = 'UpdateProfileInsightsDialog';
